export default __webpack_public_path__ + "static/media/rocket.e7eb3d83.svg";